import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

const AdminLogin = () => {
  const { login, status } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (status === "authenticated") navigate("/admin", { replace: true });
  }, [status, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login({ email, password });
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[var(--bg)] flex items-center justify-center px-6 py-24">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="mx-auto inline-flex items-center justify-center w-12 h-12 border hairline mb-6">
            <img src="/mountain-mark.png" alt="" aria-hidden className="h-5 w-auto select-none" draggable={false} />
          </div>
          <div className="text-[10px] uppercase tracking-label text-[var(--secondary-text)]">Summit Scents</div>
          <h1 className="mt-3 font-serif text-3xl md:text-4xl">Maison Admin</h1>
        </div>

        <form onSubmit={onSubmit} className="space-y-5 border hairline p-8 bg-[#0a0a0a]" data-testid="admin-login-form">
          <div>
            <label className="block text-[10px] uppercase tracking-label text-[var(--secondary-text)] mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border hairline px-4 py-3 text-sm text-[var(--primary-text)] focus:outline-none focus:border-[var(--accent-gold)]"
              data-testid="admin-login-email"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-label text-[var(--secondary-text)] mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border hairline px-4 py-3 text-sm text-[var(--primary-text)] focus:outline-none focus:border-[var(--accent-gold)]"
              data-testid="admin-login-password"
            />
          </div>
          {error && (
            <div className="text-xs text-red-400 tracking-wide" data-testid="admin-login-error">{error}</div>
          )}
          <button
            type="submit"
            disabled={busy}
            className="btn-secondary w-full disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
